import CampaignList from './CampaignList'
import { CampaignsEdit } from './CampaignsEdit'
import { CampaignsCreate } from './CampaignsCreate'

export default {
  create: CampaignsCreate,
  edit: CampaignsEdit,
  list: CampaignList,
}
